<ng-container *ngIf="isPublicRoute; then public; else private">
</ng-container>

<ng-template #public>
  <router-outlet mg-router></router-outlet>
</ng-template>

<ng-template #private>
  <div class="h-screen w-screen">
    <mg-layout [version]="version" [listSidebar]="listSidebar" [url]="url" [loading]="loading">
      <router-outlet mg-router></router-outlet>
    </mg-layout>
  </div>
</ng-template>